import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    en: {
        translation: {
            //QuestionPage.js
            'Vastaa vielä tähän': 'Answer this',
            'Vastaus on liian lyhyt': 'Answer is too short',
            'Vastaus ei ole kelvollinen': 'Invalid answer',
            'Sähköpostiosoite ei ole kelvollinen': 'Email is invalid',
            'Päivämäärä ei kelpaa': 'Date is invalid',
            'Puhelinnumero ei kelpaa': 'Phone number is invalid',
            'Postinumero ei kelpaa': 'Post code is invalid',
            'Väärän pituinen Y-tunnus': 'Business ID is invalid',
            'Viallinen Y-tunnus': 'Invalid Business ID',
            //CompanySelect.js
            'Yrityksen Y-tunnus': 'Business ID',
            'Yritystä ei löytynyt hakemasi nimen perusteella': 'Company was not found',
            'Syötä yrityksesi Y-tunnus klikkaamalla tästä': 'Input Business ID here',
            'Vaihda yritys': 'Change company',
            //AutoSuggest.js
            'Yrityksen nimi tai Y-tunnus': 'Company name or Business ID',
            'Ehdotan vaihtoehtoja': 'I will suggest options',
            //Date.js
            'Päivä': 'Day',
            'Kuukausi': 'Month',
            'Vuosi': 'Year',
            //Email.js
            'Tarkoititko': 'Did you mean',
            //Upload.js
            'Lataa lisää': 'Upload another',
            'Näytä': 'Show',
            'Piilota': 'Hide',
            //QuestionPageNavigation.js
            'Takaisin': 'Back',
            'Alustava tarjous': 'Preliminary offer',
            'Laskun summa': 'Invoice amount',
            'Kulut': 'Expenses',
            'Maksetaan tilillesi': 'Paid to you',
            'alv': 'VAT',
            'Hakemuksen lähettämisen jälkeen saat rahoitusyhtiöltä hyväksyttäväksi lopullisen tarjouksen ja sopimuksen.': 'After sending the application, you will receive a final offer and contract from the financing company for approval.',
        }
    },
    sv: {
        translation: {
            //QuestionPage.js
            'Vastaa vielä tähän': 'Vänligen svara även på detta',
            'Vastaus on liian lyhyt': 'Svaret är för kort',
            'Vastaus ei ole kelvollinen': 'Svaret är inte giltigt',
            'Sähköpostiosoite ei ole kelvollinen': 'E-postadressen är inte giltig',
            'Päivämäärä ei kelpaa': 'Datumet är inte giltigt',
            'Puhelinnumero ei kelpaa': 'Telefonnumret är inte giltigt',
            'Postinumero ei kelpaa': 'Postnumret är inte giltigt',
            'Väärän pituinen Y-tunnus': 'Organisationsnumret har fel längd',
            'Viallinen Y-tunnus': 'Organisationsnumret är ogiltigt',
            //CompanySelect.js
            'Yrityksen Y-tunnus': 'Organisationsnummer',
            'Yritystä ei löytynyt hakemasi nimen perusteella': 'Inget företag hittades baserat på det namn du sökte',
            'Syötä yrityksesi Y-tunnus klikkaamalla tästä': 'Ange ditt organisationsnummer här',
            'Vaihda yritys': 'Byt företag',
            //AutoSuggest.js
            'Yrityksen nimi tai Y-tunnus': 'Företagsnamn eller organisationsnummer',
            'Ehdotan vaihtoehtoja': 'Jag föreslår alternativ',
            //Date.js
            'Päivä': 'Dag',
            'Kuukausi': 'Månad',
            'Vuosi': 'År',
            //Email.js
            'Tarkoititko': 'Menade du',
            //Upload.js
            'Lataa lisää': 'Ladda upp fler',
            'Näytä': 'Visa',
            'Piilota': 'Dölj',
            //QuestionPageNavigation.js
            'Takaisin': 'Tillbaka',
        }
    },
    no: {
        translation: {
            //QuestionPage.js
            'Vastaa vielä tähän': 'Vennligst svar på dette igjen',
            'Vastaus on liian lyhyt': 'Svaret er for kort',
            'Vastaus ei ole kelvollinen': 'Svaret er ikke gyldig',
            'Sähköpostiosoite ei ole kelvollinen': 'E-postadressen er ikke gyldig',
            'Päivämäärä ei kelpaa': 'Datoen er ikke gyldig',
            'Puhelinnumero ei kelpaa': 'Telefonnummeret er ikke gyldig',
            'Postinumero ei kelpaa': 'Postnummeret er ikke gyldig',
            'Väärän pituinen Y-tunnus': 'Organisasjonsnummeret har feil lengde',
            'Viallinen Y-tunnus': 'Organisasjonsnummeret er ugyldig',
            //CompanySelect.js
            'Yrityksen Y-tunnus': 'Organisasjonsnummer',
            'Yritystä ei löytynyt hakemasi nimen perusteella': 'Ingen bedrift ble funnet basert på navnet du søkte',
            'Syötä yrityksesi Y-tunnus klikkaamalla tästä': 'Angi ditt organisasjonsnummer her',
            'Vaihda yritys': 'Bytt bedrift',
            //AutoSuggest.js
            'Yrityksen nimi tai Y-tunnus': 'Bedriftsnavn eller organisasjonsnummer',
            'Ehdotan vaihtoehtoja': 'Jeg foreslår alternativer',
            //Date.js
            'Päivä': 'Dag',
            'Kuukausi': 'Måned',
            'Vuosi': 'År',
            //Email.js
            'Tarkoititko': 'Mente du',
            //Upload.js
            'Lataa lisää': 'Last opp mer',
            'Näytä': 'Vis',
            'Piilota': 'Skjul',
            //QuestionPageNavigation.js
            'Takaisin': 'Tilbake',
        }
    }
}

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        //lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    })

export default i18n
